export default __webpack_public_path__ + "static/media/shout-out.cb5f7396.jpg";